// extracted by mini-css-extract-plugin
export default {"cls1":"Wb7_qtbcQ4KYIkJEd9zT","cls2":"Zm4UFN9SHfsLuaOdQJlU Wb7_qtbcQ4KYIkJEd9zT","isPhone":"HFEThfoJ2ufY8VIMIlre"};